import { Typography, useTheme } from '@mui/material';
import { TagChip } from 'components/ui';
import { TableContext } from 'pages/PatientsPage';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const GenderFilterChip = () => {
  const { t } = useTranslation();
  const theme = useTheme()
  const { filters, setFilters } = useContext(TableContext);

  const selectedGenders = filters?.gender;

  function deleteFilter(gender) {
    const newGenderFilter = filters.gender.filter((item) => item !== gender);
    setFilters({
      ...filters,
      gender: newGenderFilter,
    });
  }

  return selectedGenders?.map((gender) => (
    <TagChip
      key={gender}
      tag={
        <>
          <Typography
            component="span"
            color={theme.palette.colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Sex')}: `}
          </Typography>
          <Typography
            component="span"
            color={theme.palette.colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {t(
              gender?.charAt(0).toUpperCase() + gender?.slice(1).toLowerCase()
            )}
          </Typography>
        </>
      }
      handleDelete={() => deleteFilter(gender)}
      isCanDelete
      iconColor={theme.palette.colors.blue100}
    />
  ));
};
